<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3 mt-6 class="transparent-bg">
        <h1 class="text-center">
          Dziękujemy za skorzystanie z naszego serwisu.
        </h1>
        <blockquote class="blockquote text-center">
          Jeśli płatność przebiegła pomyślnie, zakupione warsztaty powinny
          pojawić się w zakładce Warsztaty.
        </blockquote>
        <!-- <telegram class="telegram" /> -->
        <blockquote class="blockquote text-center">
          <a class="center">
            <div class="primary-button" @click="redirect">Moje warsztaty</div>
          </a>
        </blockquote>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: "WorkshopsPaymentSuccess",
  metaInfo: {
    title: "Dagajoga warsztaty - portal jogi online",
  },
  methods: {
    redirect() {
      this.$router.push({ name: "Workshops" });
    },
  },
};
</script>

<style scoped>
.telegram {
  position: absolute;
  bottom: 0;
  right: 1rem;
}
.transparent-bg {
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px;
  position: relative;
  padding: 40px;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5;
  margin: auto;
}
i {
  font-size: 120px;
}
.center {
  display: flex;
  justify-content: center;
  margin-right: 20px;
  margin-top: 15px;
  cursor: default;
}
a {
  text-decoration: none;
}
</style>
